import { render, staticRenderFns } from "./PointListLink.vue?vue&type=template&id=4920c6c4&scoped=true&"
import script from "./PointListLink.vue?vue&type=script&lang=js&"
export * from "./PointListLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4920c6c4",
  null
  
)

export default component.exports